import { isNullish } from "../types/index.ts";

export function decodeJwtPayload(token: string): unknown {
  const parts = token.split(".");
  const payload = parts[1];

  if (isNullish(payload)) {
    return null;
  }

  try {
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}
